(function () {
    'use strict';

    angular
            .module('imnApp')
            .factory('modalWaitInterceptor', modalWaitInterceptor);

    modalWaitInterceptor.$inject = ['$q', '$injector'];

    function modalWaitInterceptor($q, $injector) {
        var service = {
            request: request,
            response: response,
            responseError: responseError
        };

        return service;

        function request(config) {
            var path = config.url;
            var method = config.method;
            var modalIsActive = true;
            constructorMethod(method, path, modalIsActive);
            return config;
        }

        function response(response) {
            var path = response.config.url;
            var method = response.config.method;
            var modalIsActive = false;
            constructorMethod(method, path, modalIsActive);
            return response;
        }

        function responseError(rejection) {
            var path = rejection.config.url;
            var method = rejection.config.method;
            var modalIsActive = false;
            constructorMethod(method, path, modalIsActive);
            return $q.reject(rejection);
        }

        // Method handler
        function getInstanceAlertModal() {
            return $injector.get('AlertModalService');
        }

        function constructorMethod(method, path, modalIsActive) {
            var dataValidCall = validCalls(method, path);
            if (dataValidCall.isValidCall) {
                var AlertModalConstructor = getInstanceAlertModal();
                AlertModalConstructor.wait(modalIsActive, dataValidCall.key);
                return;
            }
            return;
        }
        // Method to verify api accept
        function validCalls(method, path) {
            var dataValidCall = {
                isValidCall: false
            };

            if (method == 'PUT' || method == 'POST') {
                // List of api to be intercepted
                var calls = [
                    {method: 'PUT', api: 'setdatetime', key: 'setDateTime', hasPermission: 'oltSetDateTime'},
                    {method: 'PUT', api: 'loadfiles', key: 'loadFiles', hasPermission: 'oltLoadFiles'}
                ];

                calls.forEach(function (item) {
                    var authenticate = $injector.get('Authenticate');
                    if (path.indexOf(item.api) > -1) {
                        var permission = item.hasPermission || item.hasNotPermission;
                        var hasPermission = authenticate.hasPermission(permission);
                        if (item.hasNotPermission) {
                            hasPermission = !hasPermission
                        }

                        if (hasPermission) {
                            dataValidCall = {
                                isValidCall: true,
                                key: item.key
                            };
                        }
                    }
                }, this);
            }
            return dataValidCall;
        }

    }
})();